/**
 * See also /src/components/elements/InlineMarkdownEditor.tsx
 * Some differences:
 *  - This is less featureful
 *  - Editing is not triggered when text is clicked, only when edit button is clicekd. (Allows copying.)
 *  - Uses Dec 2022 design styling
 */

import Markdown from '@wandb/weave/common/components/Markdown';
import {MOON_500} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {clsx} from 'clsx';
import React, {useState} from 'react';

import TextEditor from '../../elements/TextEditor';
import * as S from './MetadataValue.styles';

type MarkdownEditorProps = {
  content: string;
  placeholder?: string;
  onSave?: (value: string) => void;
};

export const MarkdownEditor = ({
  content,
  placeholder,
  onSave,
}: MarkdownEditorProps) => {
  const [value, setValue] = useState(content);
  const [isEditing, setIsEditing] = useState(false);
  const onEdit = () => {
    setIsEditing(!isEditing);
  };
  const onChange = (newValue: string) => {
    setValue(newValue);
  };
  const onBlur = () => {
    setIsEditing(false);
    if (onSave) {
      onSave(value);
    }
  };
  const displayedContent = value || (placeholder ?? '');
  const style: React.CSSProperties = {};
  if (!value) {
    style.color = MOON_500;
    style.userSelect = 'none';
  }

  const className = clsx('inline-markdown-editor', {
    editing: isEditing,
  });

  return (
    <S.MainPanel>
      <S.ContentPanel className={className}>
        {isEditing ? (
          <TextEditor
            autoFocus
            value={value ?? ''}
            onBlur={onBlur}
            onChange={onChange}
          />
        ) : (
          <div style={style}>
            <Markdown content={displayedContent} />
          </div>
        )}
      </S.ContentPanel>
      {!isEditing && (
        <S.ButtonPanel>
          <Button
            icon="pencil-edit"
            variant="ghost"
            onClick={onEdit}
            tooltip="Click to edit"
          />
        </S.ButtonPanel>
      )}
    </S.MainPanel>
  );
};
